/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Launch_Title_1Inputs */

const en_how_we_work_launch_title_1 = /** @type {(inputs: How_We_Work_Launch_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A careful launch.`)
};

const lv_how_we_work_launch_title_1 = /** @type {(inputs: How_We_Work_Launch_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rūpīga ieviešana.`)
};

/**
* | output |
* | --- |
* | "A careful launch." |
*
* @param {How_We_Work_Launch_Title_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_launch_title_1 = /** @type {((inputs?: How_We_Work_Launch_Title_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Launch_Title_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_launch_title_1(inputs)
	return en_how_we_work_launch_title_1(inputs)
});